module.exports = __webpack_public_path__ + "img/logo.115ebfd8.svg";